<div class="container-fluid p-0 m-0">
    <app-shared status="Brouillon"></app-shared>
</div>
